import * as React from 'react';
import * as CardModal from 'src/components/CardModal';
import * as Constants from 'src/constants';
import Text from 'src/components/Text';
import { useRegisterStartState } from './useRegisterStartState';

interface PropsIface {
  phone: string;
  onSuccess: () => void;
  onBack: () => void;
}

const RegisterStartStep: React.FC<PropsIface> = (props) => {
  const registerStartState = useRegisterStartState({
    phone: props.phone,
    onSuccess: props.onSuccess,
    onBack: props.onBack,
  });

  return (
    <>
      <CardModal.Header
        errorLabel={registerStartState.errorMessage ?? undefined}
        onNext={registerStartState.onNextPress}
        onBack={registerStartState.onBackPress}
      />
      <CardModal.Body>
        <Text style={[Constants.TextStyle.T24B, Constants.GridStyle.MBUnit]}>
          {`First, let’s verify your phone number: ${props.phone}`}
        </Text>
        <Text style={[Constants.TextStyle.T16R, Constants.TextStyle.CDarkGray, Constants.GridStyle.MBUnit]}>
          {`In the next step we will send you a text message with a code to make sure you own this phone number.`}
        </Text>
        <Text style={[Constants.TextStyle.T16R, Constants.TextStyle.CDarkGray, Constants.GridStyle.MBUnit]}>
          {`This will help you recover your account if you ever lose access for some reason.`}
        </Text>
      </CardModal.Body>
    </>
  );
};

export default RegisterStartStep;
